import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'

const LoadFullSizeVariantToBeRated = ({
  productVariant,
  needsToBeRatedSample
}) => {
  const dispatch = useDispatch()

  const loadFullSizeVariant = () => {
    if (!needsToBeRatedSample) {
      return
    }

    if (!productVariant?.fullsize_variant_id) {
      return
    }

    dispatch(loadByIdDeepProductVariantAction(productVariant.fullsize_variant_id))
  }

  React.useEffect(() => {
    loadFullSizeVariant()
  }, [
    productVariant,
    needsToBeRatedSample
  ])

  return <></>
}

export default LoadFullSizeVariantToBeRated
